import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "../FormComponents/Select/Select";
import Input from "../FormComponents/Input/Input";
import carYears from "../../utils/carYears";
import insuredValues from "../../utils/insuredValues";
import { de } from "date-fns/locale";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const VehicleQuote = (props) => {
	const { makeModels, renewalId, renewalData } = props;

	const [newVehicle, setNewVehicle] = useState(false);
	const [editVehicle, setEditVehicle] = useState(false);
	const [hideCar, setHideCar] = useState(null);
	const [cars, setCars] = useState([]);

	const dispatch = useDispatch();

	// Add new vehicle
	const [vin, setVin] = useState("");
	const [year, setYear] = useState("");
	const [make, setMake] = useState("");
	const [model, setModel] = useState("");
	const [insured, setInsured] = useState("");
	const [lienHolderStatus, setLienHolderStatus] = useState("");
	const [lienHolder, setLienHolder] = useState("");
	const [carOwnerStatus, setCarOwnerStatus] = useState("");
	const [carOwner, setCarOwner] = useState("");

	const [models, setModels] = useState([]);
	const [carPosition, setCarPosition] = useState(0);

	const vinRef = useRef();
	const modelRef = useRef();
	const yearRef = useRef();
	const makeRef = useRef();
	const valueRef = useRef();
	const lienRef = useRef();
	const carOwnerRef = useRef();

	useEffect(() => {
		setCars(props.cars);
	}, [props.cars]);

	const changeCars = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, cars: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const carInsuredValuesOptions = insuredValues.insuredValues.map((value) => (
		<option value={value} key={value}>
			${numberWithCommas(value)}
		</option>
	));

	const carYearsOptions = carYears.carYears.map((year) => (
		<option value={year} key={year}>
			{year}
		</option>
	));

	const lienHolderOptions = [
		{
			value: "0",
			label: "No, the car is owned outright (there is not a lien holder)",
		},
		{ value: "1", label: "Yes, the car is leased" },
		{ value: "2", label: "Yes, the car is financed" },
	];
	const lienHolderOptionsSelect = lienHolderOptions.map((option) => (
		<option value={option.value} key={option.value}>
			{option.label}
		</option>
	));

	const carOwnerOptions = [
		{ value: "0", label: "An Individual" },
		{ value: "1", label: "A Company" },
	];
	const carOwnerOptionsSelect = carOwnerOptions.map((option) => (
		<option value={option.value} key={option.value}>
			{option.label}
		</option>
	));

	const changeDeductible = (value, index) => {
		//let newCars = cars;
		let newCars = JSON.parse(JSON.stringify(cars));
		newCars[index] = { ...newCars[index], value: value };
		setCars([...newCars]);
		changeCars([...newCars]);
	};

	useEffect(() => {
		if (makeModels) {
			let thisModels = JSON.parse(makeModels);

			thisModels = thisModels.map((model) => (
				<option value={model.make_name} key={model.id}>
					{model.make_name}
				</option>
			));
			setModels(thisModels);
		}
	}, [makeModels]);

	const getVehicleMake = (id) => {
		let thisModels = JSON.parse(makeModels);
		const vehicle = thisModels.find((model) => model.id == id);
		return vehicle ? vehicle.make_name : "";
	};

	const saveCar = (e) => {
		e.preventDefault();
		if (!checkErrorsForm()) {
			const newCar = {
				vin: vin,
				year: year,
				make: make,
				car_model: model,
				value: insured,
				lienholder_status: lienHolderStatus,
				lienholder_name: lienHolder,
				car_owner_status: carOwnerStatus,
				car_owner_name: carOwner,
			};
			setCars([...cars, newCar]);
			changeCars([...cars, newCar]);
			setNewVehicle(false);
		}
	};
	const editCar = (e) => {
		dispatch({
			type: "SET_LOADING_QUOTE",
			payload: true,
		});
		e.preventDefault();
		if (!checkErrorsForm()) {
			let newVehicles = JSON.parse(JSON.stringify(cars));
			const newVehicle = {
				vin: vin,
				year: year,
				make: make,
				car_model: model,
				value: insured,
				lienholder_status: lienHolderStatus,
				lienholder_name: lienHolder,
				car_owner_status: carOwnerStatus,
				car_owner_name: carOwner,
			};
			newVehicles[carPosition] = newVehicle;
			setCars([...newVehicles]);
			changeCars([...newVehicles]);
			setEditVehicle(false);
			setHideCar(true);
			setTimeout(function () {
				dispatch({
					type: "SET_LOADING_QUOTE",
					payload: false,
				});
			}, 1500);
		}
	};

	const removeCar = () => {
		//let array = cars;
		let array = JSON.parse(JSON.stringify(cars));
		array.splice(carPosition, 1);
		setCars(array);
		changeCars(array);
	};

	const checkErrorsForm = () => {
		let errors = false;
		let lienError = false;
		let companyError = false;

		const vinError = vinRef.current.validateInput();
		const modelError = modelRef.current.validateInput();
		const yearError = yearRef.current.validateSelect();
		const makeError = makeRef.current.validateSelect();
		const valueError = valueRef.current.validateSelect();

		if (lienHolderStatus == 1 || lienHolderStatus == 2) {
			lienError = lienRef.current.validateInput();
		}
		if (carOwnerStatus == "1") {
			companyError = carOwnerRef.current.validateInput();
		}
		if (vinError || modelError || yearError || makeError || valueError) {
			errors = true;
		} else {
			if (lienHolderStatus == 1 || lienHolderStatus == 2) {
				if (lienError) {
					errors = true;
				}
			}
		}

		return errors;
	};

	return (
		<div>
			<div className="col-12 ml-4 otmt-2">
				<h2>Vehicles</h2>
			</div>
			{cars.map((car, i) => {
				console.log(car);
				return (
					<>
						<div
							key={i}
							className={`col otmt-2 ${hideCar === i ? "d-none" : ""}`}
						>
							<div className="card mb-3">
								<div className="card-body col-12 pr-4 pr-md-0">
									<div className="mx-auto otmb-1 otmt-1 row">
										<div className="col-12 d-flex pl-0 pr-0">
											<div className="col-8 col-md-9 pl-0">
												<h3 className="pl-md-4" style={{ color: "#00778a" }}>
													{car.year} {car.make} {car.car_model}
												</h3>
											</div>
											{cars.length === 1 ? null : (
												<div className="col">
													<button
														type="button"
														id="carBtn"
														className="btn btnremove"
														onClick={() => {
															setCarPosition(i);
															removeCar();
														}}
													>
														REMOVE
													</button>
												</div>
											)}
										</div>
										<div className="mb-0 mt-3 otmb-1 pl-0 pl-md-4 d-md-flex">
											<p
												htmlFor="formGroupExampleInput"
												className="mr-3 mt-md-3 pl-0"
											>
												VEHICLE IDENTIFICATION NUMBER (VIN)
											</p>
											<h2 className="">{car.vin}</h2>
										</div>
										<div className="mb-0 otmb-1 pl-0 pl-md-4 d-md-flex">
											<p
												htmlFor="formGroupExampleInput"
												className="font-weight-bold mr-3 mt-md-3 pl-0 text-uppercase"
											>
												INSURANCE VALUE
											</p>
											<h3 className="" style={{ color: "#00778a" }}>
												{formatter.format(_.get(car, `value`, ""))}
											</h3>
											{/* 											<select
												className="col col-md-7 form-control"
												defaultValue={car.value}
												onChange={(e) => changeDeductible(e.target.value, i)}
											>
												{carInsuredValuesOptions}
											</select> */}
										</div>
										<div className="col pl-0 pl-md-4">
											<p
												type="button"
												className="mb-0"
												style={{ color: "red" }}
												onClick={() => {
													setEditVehicle(car);
													setVin(car.vin);
													setYear(car.year);
													setMake(car.make);
													setModel(car.car_model);
													setInsured(car.value);
													setCarPosition(i);
													setEditVehicle(true);
													setHideCar(i);
												}}
											>
												<u>Edit this vehicle</u>
											</p>
										</div>

										{/* <div className="otmb-1 otmt-1 pl-0 pl-md-4">
								<p type="button" className="mb-0" style={{ color: "red" }}>
									<u>Remove this vehicle</u>
								</p>
							</div> */}
									</div>
								</div>
							</div>
						</div>
						{editVehicle && (
							<div
								id="carForm"
								className={`col ${hideCar === i ? "" : "d-none"}`}
							>
								<div className="card mb-5">
									<div className="card-body col-11 mx-auto ">
										<div className="row ">
											<div className="col-10 col-md-5 pl-0">
												<h1
													className="pl-0 otmt-1 ml-md-0"
													style={{ color: "#00778a" }}
												>
													Edit vehicle
												</h1>
											</div>
											<div className="col-2 mt-2 col-md-7 d-md-flex justify-content-md-end pr-0">
												<i
													className="bi bi-x "
													onClick={() => {
														setEditVehicle(false);
														setHideCar(true);
													}}
												></i>
											</div>
										</div>
										<form onSubmit={(e) => editCar(e)}>
											<div className="d-flex row">
												<div className="pl-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">
														VEHICLE IDENTIFICATION NUMBER (VIN)
													</h5>
													<Input
														val={vin}
														setVal={setVin}
														classInput="form-control"
														validation="vin"
														ref={vinRef}
													/>
												</div>
												<div className="pr-md-0 col-md-6 col-12"></div>
												<div className="pl-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">WHO OWNS THE CAR?</h5>
													<Select
														val={carOwnerStatus}
														setVal={setCarOwnerStatus}
														options={carOwnerOptionsSelect}
														selectLabel="Make Selection"
														classSelect="form-control"
													/>
												</div>
												<div className="pr-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">
														IS THERE A LIEN HOLDER?
													</h5>
													<Select
														val={lienHolderStatus}
														setVal={setLienHolderStatus}
														options={lienHolderOptionsSelect}
														selectLabel="Make Selection"
														classSelect="form-control"
													/>
												</div>
												<div className="pl-md-0 col-md-6 col-12">
													{carOwnerStatus == "1" && (
														<>
															<h5 className="mt-4 pl-0">NAME OF COMPANY</h5>
															<Input
																val={carOwner}
																setVal={setCarOwner}
																classInput="form-control mb-md-3"
																validation="lien"
																ref={carOwnerRef}
															/>
														</>
													)}
												</div>
												<div className="pr-md-0 col-md-6 col-12">
													{(lienHolderStatus == 1 || lienHolderStatus == 2) && (
														<>
															<h5 className="mt-4 pl-0">LIEN HOLDER NAME</h5>
															<Input
																val={lienHolder}
																setVal={setLienHolder}
																classInput="form-control mb-md-3"
																validation="lien"
																ref={lienRef}
															/>
														</>
													)}
												</div>
												<div className="pl-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">YEAR</h5>
													<Select
														val={year}
														setVal={setYear}
														options={carYearsOptions}
														selectLabel="Select Year"
														classSelect="form-control"
														validation="year"
														ref={yearRef}
													/>
												</div>
												<div className="pr-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">MAKE</h5>
													<Select
														val={make}
														setVal={setMake}
														options={models}
														selectLabel="Select Make"
														classSelect="form-control"
														validation="make"
														ref={makeRef}
													/>
												</div>
												<div className="pl-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">MODEL</h5>

													<Input
														val={model}
														setVal={setModel}
														classInput="form-control"
														validation="model"
														ref={modelRef}
													/>
												</div>
												<div className="pr-md-0 col-md-6 col-12">
													<h5 className="mt-4 pl-0 mb-0">INSURED VALUE</h5>
													<Select
														val={insured}
														setVal={setInsured}
														options={carInsuredValuesOptions}
														selectLabel="Select Value"
														classSelect="form-control"
														validation="value"
														ref={valueRef}
													/>
												</div>
											</div>
											<div className="row">
												<div className="d-md-flex justify-content-md-end otmb-1">
													{/* <div className="mr-md-4 otmt-2">
													<button
														type="button"
														className="col-12 btn btn1 btn-lg"
														onClick={() => setShowNewCar(false)}
													>
														CANCEL
													</button>
												</div> */}
													<div className="otmt-2">
														<button
															type="submit"
															className="col-12 btn btn2 btn-lg"
															style={{ minWidth: "160px" }}
														>
															EDIT VEHICLE
														</button>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						)}
					</>
				);
			})}
			{!newVehicle && (
				<div className="col-12 d-flex justify-content-center otmt-2">
					<button
						type="button"
						id="carBtn"
						className="btn btn1 col-6"
						onClick={() => {
							setVin("");
							setYear("");
							setMake("");
							setModel("");
							setInsured("");
							setLienHolderStatus("");
							setCarOwnerStatus("");
							setNewVehicle(true);
							setEditVehicle(null);
						}}
					>
						ADD A VEHICLE
					</button>
				</div>
			)}

			{newVehicle && (
				<div id="carForm" className="col">
					<div className="card mb-5">
						<div className="card-body col-11 mx-auto ">
							<div className="row ">
								<div className="col-10 col-md-5 pl-0">
									<h1
										className="pl-0 otmt-1 ml-md-0"
										style={{ color: "#00778a" }}
									>
										Add a vehicle
									</h1>
								</div>
								<div className="col-2 mt-2 col-md-7 d-md-flex justify-content-md-end pr-0">
									<i
										className="bi bi-x "
										onClick={() => {
											setNewVehicle(false);
											setHideCar(true);
										}}
									></i>
								</div>
							</div>
							<form onSubmit={(e) => saveCar(e)}>
								<div className="d-flex row">
									<div className="pl-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">
											VEHICLE IDENTIFICATION NUMBER (VIN)
										</h5>
										<Input
											val={vin}
											setVal={setVin}
											classInput="form-control"
											validation="vin"
											ref={vinRef}
										/>
									</div>
									<div className="pr-md-0 col-md-6 col-12"></div>
									<div className="pl-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">WHO OWNS THE CAR?</h5>
										<Select
											val={carOwnerStatus}
											setVal={setCarOwnerStatus}
											options={carOwnerOptionsSelect}
											selectLabel="Make Selection"
											classSelect="form-control"
										/>
									</div>
									<div className="pr-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">IS THERE A LIEN HOLDER?</h5>
										<Select
											val={lienHolderStatus}
											setVal={setLienHolderStatus}
											options={lienHolderOptionsSelect}
											selectLabel="Make Selection"
											classSelect="form-control"
										/>
									</div>
									<div className="pl-md-0 col-md-6 col-12">
										{carOwnerStatus == "company" && (
											<>
												<h5 className="mt-4 pl-0">NAME OF COMPANY</h5>
												<Input
													val={carOwner}
													setVal={setCarOwner}
													classInput="form-control mb-md-3"
													validation="lien"
													ref={carOwnerRef}
												/>
											</>
										)}
									</div>
									<div className="pr-md-0 col-md-6 col-12">
										{(lienHolderStatus == 1 || lienHolderStatus == 2) && (
											<>
												<h5 className="mt-4 pl-0">LIEN HOLDER NAME</h5>
												<Input
													val={lienHolder}
													setVal={setLienHolder}
													classInput="form-control mb-md-3"
													validation="lien"
													ref={lienRef}
												/>
											</>
										)}
									</div>
									<div className="pl-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">YEAR</h5>
										<Select
											val={year}
											setVal={setYear}
											options={carYearsOptions}
											selectLabel="Select Year"
											classSelect="form-control"
											validation="year"
											ref={yearRef}
										/>
									</div>
									<div className="pr-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">MAKE</h5>
										<Select
											val={make}
											setVal={setMake}
											options={models}
											selectLabel="Select Make"
											classSelect="form-control"
											validation="make"
											ref={makeRef}
										/>
									</div>
									<div className="pl-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">MODEL</h5>

										<Input
											val={model}
											setVal={setModel}
											classInput="form-control"
											validation="model"
											ref={modelRef}
										/>
									</div>
									<div className="pr-md-0 col-md-6 col-12">
										<h5 className="mt-4 pl-0 mb-0">INSURED VALUE</h5>
										<Select
											val={insured}
											setVal={setInsured}
											options={carInsuredValuesOptions}
											selectLabel="Select Value"
											classSelect="form-control"
											validation="value"
											ref={valueRef}
										/>
									</div>
								</div>
								<div className="row">
									<div className="d-md-flex justify-content-md-end otmb-1">
										{/* <div className="mr-md-4 otmt-2">
											<button
												type="button"
												className="col-12 btn btn1 btn-lg"
												onClick={() => setShowNewCar(false)}
											>
												CANCEL
											</button>
										</div> */}
										<div className="otmt-2">
											<button
												type="submit"
												className="col-12 btn btn2 btn-lg"
												style={{ minWidth: "160px" }}
											>
												ADD VEHICLE
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default VehicleQuote;
